import { signal } from "@preact/signals-react";
import { useEffect } from "react";
import { addNotification } from "../stores/notification-store";

const config = signal(null)
const error = signal(null)
const loading = signal(false)
const isLoaded = signal(false)

const fetchData = async () => {
    // short-circuit if we have a pending request or have already received an error
    if (loading.value || error.value) {
        return
    }

    // short-circuit if we alreaady have the data
    if (config.value && isLoaded.value) {
        return
    }

    try {
        loading.value = true

        let response = await fetch('/config.json')
        let data = await response.json()
        config.value = data

        // sets the variable on the global windows object so the jsonforms code can determine if it should log verbosely
        globalThis.DYNAMIC_RUNTIME_VERBOSE = !!data.verboseJsonFormsLogging
        console.log('Set DYNAMIC_RUNTIME_VERBOSE to', globalThis.DYNAMIC_RUNTIME_VERBOSE)
        isLoaded.value = true
    }
    catch(err) {
        error.value = err
        console.log(err)
        addNotification(`Unable to load configuration data: ${err}`)
    }
    finally {
        loading.value = false
    }
}

const useConfig = () => {
    useEffect(() => {
        fetchData()
    }) // run effect everytime

    return {
        config, loading, isLoaded, error
    }
}

export default useConfig
